Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  basic_more: 'More',
  app_name: 'iM Football',
  match_postponed: 'Postponed',
  match_abandoned: 'Abandoned',
  home_match: 'Home',
  away_match: 'Away',
  no_start_time: 'Not available',
  own_goal: '(OG)',
  last_day: 'yesterday',
  tomorrow: 'tomorrow',
  at_date: 'at',
  teaser_date_prefix: ' ',
  source_prefix: 'by',
  source_join: 'and',
  theme: 'Theme',
  minute_short: 'mins ago',
  ranking_title_GOALS: 'Goals',
  ranking_title_SCORER: 'Scorer',
  ranking_title_ASSISTS: 'Assists',
  ranking_title_YELLOW_CARDS: 'Yellow cards',
  ranking_title_RED_CARDS: 'Red cards',
  ranking_header_goals: 'Goals',
  ranking_header_points: 'Pt',
  ranking_header_assists: 'Ass',
  ranking_header_yellow_cards: 'Yellow',
  ranking_header_red_cards: 'Red',
  years: 'years',
  bet_on_tip: 'Now bet on this tip!',
  wager: 'Wager',
  profit: 'Profit',
  sponsored: 'sponsored by',
  quote: 'Quote',
  more_than: 'More than',
  less_than: 'Less than',
  group: 'Group',
  ticker: 'Ticker',
  conference: 'Conference',
  line_up: 'Line up',
  standings: 'Standings',
  statistics: 'Statistics',
  favorites: 'Favorites',
  top_competitions: 'Top competitions',
  all_competitions: 'All competitions',
  info: 'Info',
  gameplan: 'Gameplan',
  match_day: 'Match Day',
  round: 'Round',
  no_events: 'There are no events on this day!',
  squad: 'Squad',
  ranking: 'Rankings',
  feed: 'Feed',
  position_GOALKEEPER: 'Goal',
  position_DEFENDER: 'Defence',
  position_MIDFIELDER: 'Midfield',
  position_FORWARD: 'Offence',
  position_TRAINER: 'Coach',
  show_more: 'Show more',
  show_less: 'Show less',
  fetching_data_error: 'Error fetching data.',
  fetching_data_empty: 'No data received.',
  refreshing_data_error: 'Data could not have been refreshed',
  formation_bench: 'Bench',
  formation_substitution: 'Substitution',
  penalty_shootout: 'Penalty shootout',
  standings_qualify: {
    champions_league: 'Champions League',
    champions_league_quali: 'Champions League Qualification',
    europa_league: 'Europa League',
    europa_league_quali: 'Europa League Qualification',
    europa_league_play_offs: 'Europa League Play-Offs',
    way_down_relegation: 'Way down Relegation',
    way_down_play_offs: 'Way down Play-Offs',
    way_down: 'Way down',
    promotion: 'Promotion',
    promotion_relegation: 'Promotion Relegation',
    promotion_play_offs: 'Promotion Play-Offs'
  },
  statistic_entries: {
    GENERAL: 'General',
    TOTAL_SHOTS_ON_TARGET: 'Total shots on goal',
    PERCENTAGE_PASS: 'Pass percentage',
    POSSESSION_PERCENTAGE: 'Possession percentage',
    DISTANCE: 'Distance (km)',
    TOTAL_YELLOW_CARD: 'Total yellow cards',
    SENDING_OFF: 'Total sending offs',
    TRACKING: 'Tracking',
    SPRINTS: 'Sprints',
    AVG_SPEED: 'Averaged speed (km/h)',
    OFFENSIVE: 'Offensive',
    GOALS: 'Goals',
    TOTAL_SHOTS: 'Total shots',
    PERCENTAGE_SHOTS_ON_GOAL: 'Shot accuracy',
    TOTAL_CHANCES: 'Total chances',
    WON_CONTEST: 'Successful dribblings',
    FOULS_WON: 'Won fouls',
    CORNERS: 'Corners',
    FREEKICK: 'Freekicks',
    TOTAL_OFFSIDES: 'Total offsides',
    DEFENSIVE: 'Defensive',
    BLOCKED_PASS: 'Blocked passes',
    BLOCKED_CROSS: 'Blocked crosses',
    TOTAL_CLEARANCE: 'Total clearance',
    FOULS: 'Fouls',
    GOALKEEPER: 'Goalkeeper',
    SAVES: 'Saves',
    GOOD_HIGH_CLAIM: 'Good high claim',
    PASS: 'Passes',
    TOTAL_PASS: 'Total passes',
    ACCURATE_PASS: 'Accurate passes',
    TOTAL_CROSS: 'Total crosses',
    ACCURATE_CROSS: 'Accurate crosses',
    ACCURATE_CROSS_PERCENTAGE: 'Accurate cross percetange',
    LONG_BALLS: 'Long balls (over 30 meters)',
    ACCURATE_LONG_BALLS: 'Accurate long balls',
    TACKLE: 'Tackles',
    TOTAL_TACKLE: 'Total tackles',
    DUEL_WON: 'Duels won',
    DUEL_PERCENTAGE: 'Duel percentage',
    AERIAL_WON: 'Aerial won',
    BALL_POSSESSION: 'Ball possession',
    BALL_TOUCHES: 'Ball touches',
    BALL_LOST: 'Balls lost'
  },
  live: 'Live',
  news: 'News',
  newsticker: 'Newsticker',
  no_news: 'No News',
  form_title: 'Form',
  form_label: 'Last five matches',
  form: {
    WIN: 'W',
    DRAW: 'D',
    LOST: 'L'
  },
  next_match: 'Next match',
  trainer: 'Trainer',
  stadium: 'Stadium',
  seats: 'seats',
  strong_feet_entries: {
    RIGHT: 'Right',
    LEFT: 'Left',
    BOTH: 'Both'
  },
  player_info: {
    join_date: 'In club since',
    jersey_number: 'Jersey Number',
    nationality: 'Nationality',
    birthday: 'Birthday',
    age: 'Age',
    height: 'Height',
    weight: 'Weight',
    strong_feet: 'Strong feet'
  },
  general: {
    gameplan_entries: {
      ROUND: 'Round',
      SEMI_FINALS: 'Semi-Finals',
      THIRD_PLACE: '3rd and 4th Place',
      FIFTH_PLACE: '5th and 6nd Place',
      SEVENTH_PLACE: '7th and 8th Place',
      NINTH_PLACE: '9th and 10th Place',
      ELEVENTH_PLACE: '11th and 12th Place',
      THIRTEENTH_PLACE: '13th and 14th Place',
      FIFTEENTH_PLACE: '15th and 16th Place',
      SEVENTEENTH_PLACE: '17th and 18th Place',
      NINETEENTH_PLACE: '19th and 20th Place',
      TWENTY_FIRST_PLACE: '21st and 22nd Place',
      TWENTY_THIRD_PLACE: '23rd and 24th Place',
      FINAL: 'Final',
      QUARTER_FINALS: 'Quarter-Finals',
      ROUND_OF_16: 'Round of 16',
      ROUND_OF_32: 'Round of 32',
      ROUND_OF_64: 'Round of 64',
      ROUND_OF_128: 'Round of 128',
      PLAY_OFFS: 'Play-Offs',
      THIRD_PLACE_PLAY_OFF: 'Playoff 3rd and 4th Place',
      QUALIFIER_ROUND: 'Qualifier Round',
      PRACTICE: 'Training',
      PRACTICE_1: '1st Training',
      PRACTICE_2: '2nd Training',
      PRACTICE_3: '3rd Training',
      PRACTICE_4: '4th Training',
      PRACTICE_5: '5th Training',
      PRACTICE_6: '6th Training',
      PRACTICE_7: '7th Training',
      PRACTICE_8: '8th Training',
      PRACTICE_9: '9th Training',
      QUALIFYING: 'Qualifier Round',
      QUALIFYING_1: 'Qualifier Round 1',
      QUALIFYING_2: 'Qualifier Round 2',
      QUALIFYING_3: 'Qualifier Round 3',
      RACE: 'Race',
      RACE_1: '1st Race',
      RACE_2: '2nd Race',
      RACE_3: '3rd Race',
      RACE_SUPERPOLE: 'Superpole',
      PLACEMENT_QUALIFICATION_MATCH: 'Placement Qualification Match',
      EMPTY_PLAYOFF_ROUND_TYPE: 'Final Round',
      STAGE_1: '1st Stage',
      STAGE_2: '2nd Stage',
      STAGE_3: '3rd Stage',
      STAGE_4: '4th Stage',
      STAGE_5: '5th Stage',
      STAGE_6: '6th Stage',
      STAGE_7: '7th Stage',
      STAGE_8: '8th Stage',
      STAGE_9: '9th Stage',
      STAGE_10: '10th Stage',
      STAGE_11: '11th Stage',
      STAGE_12: '12th Stage',
      STAGE_13: '13th Stage',
      STAGE_14: '14th Stage',
      STAGE_15: '15th Stage',
      STAGE_16: '16th Stage',
      STAGE_17: '17th Stage',
      STAGE_18: '18th Stage',
      STAGE_19: '19th Stage',
      STAGE_20: '20th Stage',
      STAGE_21: '21st Stage',
      STAGE_22: '22nd Stage',
      STAGE_23: '23rd Stage',
      STAGE_24: '24th Stage',
      STAGE_25: '25th Stage',
      PROLOGUE: 'Prologue'
    }
  },
  motorsport: {
    gameplan_entries: {
      QUALIFYING: 'Qualifying',
      QUALIFYING_1: 'Qualifying 1',
      QUALIFYING_2: 'Qualifying 2',
      QUALIFYING_3: 'Qualifying 3'
    }
  },
  settings: {
    TITLE: 'Settings',
    categories: {
      PUSH_MESSAGES: 'Manage Push Messages',
      VIDEO_AUTO_PLAY: 'Video-Autoplay',
      BOOKMARKS: 'Bookmarks',
      fqa: 'FAQ',
      IM_FOOTBALL_RECOMMEND: 'Recommend iM Football',
      IM_FOOTBALL_EVALUATE: 'Evaluate iM Football',
      CONTACT: 'Feedback/Contact',
      'data-privacy': 'Data Privacy',
      impressum: 'Impressum'
    },
    favorite_types: {
      TITLE: 'Your Favorites',
      team: 'Teams',
      player: 'Players',
      competition: 'Competitions',
      interest: 'Interests',
      GOAL_ALARM: 'Standard-Goalalarm'
    },
    interests: {
      BREAKING_NEWS: 'Breaking News',
      GAMING: 'Gaming'
    },
    push_types: {
      TOP_NEWS: 'Top-News',
      LINEUP: 'Lineup',
      GAME_START_END: 'Game Start/End',
      STARTEND_GAME: 'Game Start/End',
      QUARTER_END: 'Half-time',
      GOALS: 'Goals',
      GOAL: 'Goals',
      SENDING_OFF: 'Dismissals',
      RED_CARD: 'Dismissals',
      YELLOW_CARD: 'Yellow Cards',
      YELLOW_CARDS: 'Yellow Cards',
      SUBSTITUTIONS: 'Substitutions',
      TRANSFERS: 'Transfers',
      FINAL_RESULT: 'Final Result',
      FINAL_SCORE: 'Final Result',
      LINEUP_AVAILABLE: 'Lineup available'
    },
    auto_play: {
      WLAN: 'Only in W-LAN',
      WLAN_AND_MOBILE: 'W-LAN and Mobile Data',
      OFF: 'Off'
    },
    privacy: {
      decline: "I don't accept",
      accept: 'Accept and continue'
    },
    IM_FOOTBALL_RECOMMEND: {
      message: 'Follow your team and players. Download it now for Android or iOS.',
      title: 'Get the new iM Football App'
    },
    CONTACT: {
      subject: 'Feedback to the iM Football App',
      body: ''
    }
  },
  no_live_games: 'Currently no live games',
  search: {
    popular: 'Popular',
    teams: 'Teams',
    players: 'Player',
    competitions: 'Competitions',
    label: 'Search for a Team, Competition or Player'
  },
  nav_bar: {
    feed: 'For you',
    news: 'News',
    live: 'Live',
    search: 'Search'
  },
  onboarding: {
    teams: 'Choose at least one team:',
    back: 'Back',
    continue: 'Continue',
    finish: 'Finish'
  },
  share_text_extern: 'Share on',
  download: 'Download for free now:',
  empty_message: {
    ARTICLE: 'No articles were found.',
    CONTENT: 'No articles were found.',
    FEED: 'Currently no content available.',
    GALLERY: 'No images were found for this gallery.',
    GAMEPLAN: 'No gameplan was found for this competition.',
    TEAM_MATCHES: 'No games were found for this team.',
    COMPETITION_MATCHES: 'No games found for this competition.',
    LINEUP: 'No lineups available for this game.',
    LIVETICKER: 'The game has not started yet',
    CONFERENCETICKER: 'There is no ticker for these games available.',
    PRE_LIVETICKER: 'Currently there is no available ticker for this game.',
    PRE_CONFERENCETICKER: 'Currently there is no available ticker for these games.',
    PRE_CONFERENCETICKER_WITH_DATE: 'The ticker starts {{ matchDate }} at {{ matchTime }}',
    CONFERENCETICKER_NO_MATCHES: 'There are no matches on {{ matchDate }}.',
    MAIN_FEED: 'Choose more favourites to get more content.',
    MATCH: 'No data found for the match.',
    NEWS: 'No news available.',
    PLAYER: 'No information found for this player.',
    RANKING_ALL: 'No rankings were found for this competition.',
    RANKING_TYPE: 'No rankings were found.',
    SCORE: 'No games were found.',
    SCORE_WIDGET: 'There are no games for your favorites.',
    SEARCH: 'No results found.',
    SQUAD: 'No squad available for this team.',
    STANDINGS: 'No standings available for this competition.',
    STATISTICS: 'No statistics available for this game.',
    TEAM_INFO: 'No information were found for this team.',
    TRANSFER: 'There are no transfers available.',
    PLAY_OFFS: 'There are no Playoffs available.'
  },
  pop_up_team_favourited: 'You have activated the goal alarm for one of the teams. Please adjust your notifications in the settings menu.',
  result: {
    after_extra_time: 'a.e.t.',
    penalty_shootout: 'a.p.s.'
  },
  feedback_message: 'Wir benutzen zur Bearbeitung dieser Kundenanfragen das Ticketsystem Zendesk, eine Kundenserviceplattform der Zendesk Inc., 989 Market Street %23300, San Francisco, CA 94102. Zendesk ist ein Service aus den USA und ist Privacy Shield zertifiziert https://www.privacyshield.gov/participant?id=a2zt0000000TOjeAAG.\n \nZur Bereitstellung der Services kooperiert die Zendesk Inc. mit weiteren Dienstleistern.\n \n- GoodData Corporation: Die GoodData Coperation („GoodData“) dient als Analyse Provider für die Bereitstellung der Insights. Speicherort: Vereinigte Staaten (Amerika)\n- Smyte, Inc.: Smyte, Inc. ("Smyte") ist ein Anbieter zur Verhinderung von Betrugsfällen.\nZendesk verwendet Smyte um die unrechtmäßige Nutzung abzuwenden. Im Zusammenhang mit der Bereitstellung ihrer Dienste hat Smyte Zugriff auf folgende Datentypen: E-Mail-Adresse des Eigentümers, E-Mail-Adresse des Agenten, E-Mail-Adresse des Endnutzers, IP-Adresse der Eigentümer, Vertreter und Endnutzer, Subdomain des Abonnenten, Fingerabdruck des Geräts, Abonnentenfirma Name, Name des Eigentümers, Telefonnummer des Inhabers, SMS-Überprüfung und Kontoverhalten, z. B. Zeitaufwand für eine Seite, angeklickte Elemente, öffentlich gepostete Inhalte der Hilfe usw. Speicherort: Vereinigte Staaten (Amerika)\n \nAls Datencenter verwendet die Zendesk Inc. folgende Anbieter:\n \n- Equinix, Inc. – Irland, Deutschland\n- Raging Wire Enterprise Solutions, Inc. – Vereinigte Staaten (Amerika)\n \nWenn Sie uns eine Anfrage per Email senden, wird Ihr Name und E-Mail-Adresse ausschließlich für die jeweilige Korrespondenz und Rückantwort mit Ihnen verwendet.\n \nFür die Beantwortung Ihrer Fragen werden folgende Daten erhoben und verarbeitet:\n \n- Empfänger - Email, die verschiedenen Mailserver welche das Email passiert haben, Bericht des SpamServers, Adresse des Empfänger– MailServers, Datum und Uhrzeit der Email, Sender – Email, Betreff, Inhalt der Email\n- Jegliche Art von Anhängen\n \nDie für die Kommunikation mit Ihnen benötigten Daten werden in unterschiedlichen Bereichen verarbeitet:\n \n- Ticket – Daten (Anfrage, Antwort, Kommentare, Schlagwörter, Benutzerdefinierte Felder und Audit Events): Speicherung im europäischen Wirtschaftsraum (EEA) oder Vereinigten Staaten (Amerika)\n- Benutzerdaten (Name, Email): Speicherung im europäischen Wirtschaftsraum (EEA) oder Vereinigten Staaten (Amerika)\n- Attachments (Jegliche Art von Anhängen): Speicherung im europäischen Wirtschaftsraum (EEA) oder Vereinigten Staaten (Amerika)\n- Insights (Anonymisierte und aggregierte Analyse): Speicherung innerhalb der Vereinigten Staaten (Amerika)\n \nBitte beachten Sie, dass bei der Kommunikation mittels E-Mail die Datensicherheit im Internet von Seiten von SPORT1 nicht gewährleistet werden kann und SPORT1 bei der Übersendung von vertraulichen Informationen zur Vorbeugung des Verlustes dieser vertraulichen Informationen den Postweg empfiehlt.\n \nWeitere Informationen finden Sie in unseren Datenschutzbestimmungen: https://www.sport1.de/unternehmen/datenschutz-mobile-imfootball',
  home_feed_end_reached: 'Follow more teams, players and competitions for more content.',
  end_reached: {
    HOME_FEED: 'Follow more teams, players and competitions for more content.'
  },
  notification: {
    GOALALARM_ACTIVE: 'Notifications active',
    GOALALARM_INACTIVE: 'Notifications inactive',
    FAV_IN: "You're now following {{ name }}",
    FAV_OUT: 'You stopped following {{ name }}',
    ERROR: 'Currently you cannot follow {{name}}',
    TEAM_FAVOURITED: 'You have activated the goal alarm for one of the teams. Please adjust your notifications in the settings menu.'
  },
  transfer: {
    SINCE: 'Since',
    NO_CLUB: 'No club affiliation',
    LOAN: 'Loan'
  },
  standings_header: {
    TEAM: 'Team',
    PLAYED: 'Pl',
    WIN: 'W',
    DRAW: 'D',
    LOOSE: 'L',
    GOALS: 'Goals',
    POINTS: 'Pts',
    DIFF: 'Aggr.',
    TIME: 'Time'
  },
  liveticker: {
    details: 'Details',
    overview: 'Close',
    GOAL: 'Goal',
    PENALTY_GOAL: 'Penalty scored',
    PENALTY_WON: 'Penalty',
    PENALTY_MISS: 'Penalty missed',
    PENALTY_SAVED: 'Penalty saved',
    RED_CARD: 'Red card',
    YELLOW_CARD: 'Yellow card',
    SECOND_YELLOW_CARD: 'Red-Yellow card',
    OWN_GOAL: 'Own Goal',
    SUBSTITUTION: 'Substitution',
    VIDEO_REFEREE: 'Video assistant referee',
    END: {
      FIRST_HALF: 'End 1. Half',
      FIRST_HALF_STOP: 'End 1. Half',
      SECOND_HALF: 'End 2. Half',
      SECOND_HALF_STOP: 'End 2. Half',
      FIRST_EXTRA_PERIOD: 'End 1. Extra period',
      FIRST_EXTRA_PERIOD_STOP: 'End 1. Extra period',
      SECOND_EXTRA_PERIOD: 'End 2. Extra period',
      SECOND_EXTRA_PERIOD_STOP: 'End 2. Extra period',
      PENALTY_SHOOTOUT: 'End of Penalty Shootout',
      END_OF_MATCH: 'End of Match'
    },
    START: {
      FIRST_HALF: 'Start 1. Half',
      SECOND_HALF: 'Start 2. Half',
      FIRST_EXTRA_PERIOD: 'Start 1. Extra period',
      SECOND_EXTRA_PERIOD: 'Start 2. Extra period',
      PENALTY_SHOOTOUT: 'Penalty Shootout'
    },
    FULL_TIME: 'End of Match'
  },
  today: 'Today',
  search_hint: 'Search for team, competition or player',
  add_favorites_hint: 'Favorite your preferred teams, player and competitions',
  download_app_hint: 'Download the iM Football app and create your own personal feed',
  open_app: 'In App',
  cancel: 'Cancel',
  impressum: 'Imprint',
  data_privacy: 'Data Privacy',
  search_results: 'Search results of:',
  share: {
    standard: 'Hey, look at this in the iM Football App: ',
    ticker: '{{ homeTeam }} - {{ awayTeam }} at iM Football Ticker'
  },
  default_ad_label: 'Check out now',
  inactive: 'Inactive',
  referee: 'Referee'
};
exports.default = _default;